const generator = require('./sale-fullcont-multitable-generator')
const timeDate  = require ('../../../../../js-handler/time-date')

export function start(detail){  //console.log('gmt>', detail)
      obj[detail.act].start(detail)
}/**/

const obj = {
      add: { start: (detail)=>{ add(detail) }},
}

//add line
function add(detail){ 
	saleMT.forEach((mt)=>{
		if(mt.tableName === detail.tableName){
			//se agrego propiedad de tab para validar si se esta creando el la linea por medio del boton tab
			//si es asi pues solo has un focus
			if (detail.tab == undefined) {
				mt.add()
			}else{
				mt.add(detail.tab)
			}
		}/*if*/
	}) 
}

export const saleMT = [

	{
		tableName: "sale_vs_item", 
		value:'', 
		id:'sale_form_sale_vs_item',
		html:'',
		data:     [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{
				name:      'purchase_vs_itemId', 
				type:      'autocomplete',
				html:      '',
				required:  true,  
			},
			{
				name:      'selling_type', 
				type:      'textfield',
				html:      '',
				required:  false,  
			},
			{
			  name:      'qty', 
			  type:      'textfield',
			  html:      '',
			  required:  true, 
			   
			},
			{
				name:      'returned_qty', 
				type:      'textfield',
				html:      '',
				required:  false,  
			},
			{
				name:      'cost', 
				type:      'textfield',
				html:      '',
				required:  false,  
			},
			{
				name:      'cogs_row_amount', 
				type:      'textfield',
				html:      '',
				required:  false,  
			},
			{
			  name:      'price', 
			  type:      'textfield',
			  html:      '',
			  required:  true,  
			},
			{
				name:      'total', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
		],

		generator: function(line){ 
			return generator.sale_vs_item(line.id, line.purchase_vs_itemId) 
		},
		add: function(tab = false){ 
			const newLine = generator.sale_vs_item('')
			this.html.insertAdjacentHTML("beforeend", newLine) 

			//select the last input
			const allLines    = this.html.querySelectorAll('.purchase_vs_itemId')
			const lastLine    = allLines[allLines.length - 1]
			const targetInput = lastLine.querySelector('input')
			
			targetInput.focus()
			if (!tab) {
				targetInput.click()
			}

		}
	},
	{
		tableName: "sale_vs_return", 
		value:'', 
		id:'sale_form_sale_vs_return',
		html:'',
		data:     [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{
				name:      'sale_vs_itemId', 
				type:      'autocomplete',
				html:      '',
				required:  true,  
			},

			{ 
				name:      'lost_qty', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},

			{
				name:      'lost_price', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
	

			{ 
				name:      "date", 
				value:     '0000-00-00', 
				date:      true,	
				html:	 	 '',
				type:		 'textfield',
				required:  true,  
			}, 


			{ 
				name:      'notes', 
				type:      'textfield',
				html:      '',
				required:  false,  
			},

		],

		generator: function(line){ 
			return generator.sale_vs_return(line.id) 
		},

		add: function(){ 
			const newLine = generator.sale_vs_return('')
			this.html.insertAdjacentHTML("beforeend", newLine) 
			
			const allLines    = this.html.querySelectorAll('.line')
			const lastLine    = allLines[allLines.length - 1]

			const input_item  = lastLine.querySelector('.sale_vs_itemId') 
			const targetInput = input_item.querySelector('input')
			targetInput.focus()
			targetInput.click()

			const input_date  = lastLine.querySelector('.date input');
			input_date.value  = timeDate.convertDateToInput();

		} 
	}

]
